import { bool, shape, string, number } from "prop-types"
import { Box } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"
import { colors } from "components/shared/admin_colors"

const AttendeeDetail = ({
  attendee,
  hideSelectionType = false,
  event: { attendeeTypes = [] } = {}
}) => {
  const promoteWouldExceedCapacity = attendeeTypes.find(
    attendeeType => attendeeType.id === attendee.attendeeTypeId
  )?.at_maximum_capacity

  const tooltipText =
    "When you promote this attendee, the capacity will be increased automatically."

  return (
    <span className={`${attendee.isCanceled ? "t-strike c-neutral-500" : ""}`}>
      {attendee.name}
      {attendee.isCanceled && " (canceled)"}
      {!hideSelectionType && (
        <div className="d-f">
          <span className="ml-1 font-size-4 c-neutral-400">{attendee.attendeeTypeName}</span>
          {attendee.isWaitlisted && promoteWouldExceedCapacity && !attendee.isCanceled && (
            <Box paddingHorizontal={2} data-tooltip={tooltipText}>
              <Icon
                symbol="general#exclamation-triangle"
                style={{ color: colors.warning }}
                aria-label={tooltipText}
              />
            </Box>
          )}
        </div>
      )}
    </span>
  )
}

AttendeeDetail.propTypes = {
  attendee: shape({
    isCanceled: bool,
    name: string,
    attendeeTypeName: string
  }).isRequired,
  hideSelectionType: bool,
  event: shape({
    attendeeTypes: shape({
      id: number,
      at_maximum_capacity: bool
    })
  })
}

export default AttendeeDetail
